<template>
    <div class="card">
        <div class="card-header bg-transparent text-left">
            <div class="row" >
                <div class="col-10 text-md-left text-center" >
                    <strong>10 Produtos mais vendidos {{periodText}}</strong>
                </div>
                <div class="col-2 text-md-right text-center" >
                    <font-awesome-icon icon="sync" @click="getData()" rel="tooltip" title="Atualizar dados do gráfico" role="button" />
                </div>
            </div>
        </div>

        <div class="card-body">
            <div class="table-responsive" >
                <table class="table table-sm table-bordered table-striped table-hover" v-if="isLoading" >
                    <thead>
                        <tr>
                            <th>Descrição</th>
                            <th @click="orderBy('desc', 'QUANTIDADE')">
                                Qtd
                                <font-awesome-icon v-if="pCurrentSort === 'QUANTIDADE' && currentSortDir === 'desc'" icon="angle-double-down" />
                                <!-- <i v-if="pCurrentSort === 'QUANTIDADE' && currentSortDir === 'asc'" class="fa fa-angle-double-down" aria-hidden="true"></i>
                                <i v-if="pCurrentSort === 'QUANTIDADE' && currentSortDir === 'desc'" class="fa fa-angle-double-up" aria-hidden="true"></i> -->
                            </th>
                            <th @click="orderBy('desc', 'VALOR_TOTAL_PRODUTO')" >
                                Valor total
                                <font-awesome-icon v-if="pCurrentSort === 'VALOR_TOTAL_PRODUTO' && currentSortDir === 'desc'" icon="angle-double-down" />
                                <!-- <i v-if="pCurrentSort === 'VALOR_TOTAL_PRODUTO' && currentSortDir === 'asc'" class="fa fa-angle-double-down" aria-hidden="true"></i>
                                <i v-if="pCurrentSort === 'VALOR_TOTAL_PRODUTO' && currentSortDir === 'desc'" class="fa fa-angle-double-up" aria-hidden="true"></i> -->
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="d in data" :key="d.id" >
                            <td>{{d.DESCRICAO}}</td>
                            <td>{{d.QUANTIDADE}}</td>
                            <td>{{formater(d.VALOR_TOTAL_PRODUTO)}}</td>
                        </tr>
                    </tbody>
                </table>

                <font-awesome-icon v-else icon="spinner" size="2x" spin  />
            </div>
        </div>

        <div class="card-footer bg-transparent text-left" v-if="pShowPeriod" >
            <div class="row" >
                <div class="col-md-6 col-12 text-md-left text-center py-1" >
                    <div class="btn-group" role="group" aria-label="Basic example">
                        <button type="button" v-bind:class="[order.active ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="orderF(true, 0)" class="btn btn-sm">Quantidade</button>
                        <button type="button" v-bind:class="[!order.active ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="orderF(false, 1)"  class="btn btn-sm">Valor</button>
                    </div>
                </div>
                <div class="col-md-6 col-12 text-md-right text-center py-1" >
                    <div class="btn-group" role="group" aria-label="Basic example">
                        <button type="button" v-bind:class="[active ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="[period = 7, active = true]" class="btn btn-sm">7 Dias</button>
                        <button type="button" v-bind:class="[!active ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="[period = 1, active = false]"  class="btn btn-sm">Hoje</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'productsMostSaled',
        data(){
            return{
                order: {
                    active: false,
                    column: 1
                },
                data: [],
                isLoading: false,
                period: 1,
                active: false,
                pShowPeriod: true,
                periodText: 'no ultimo 1 Dia',
                pCurrentSort: 'QUANTIDADE',
                currentSortDir: 'desc'
            }
        },
        computed: {
            getToken(){
                return this.$store.getters.getToken
            }
        },
        methods: {
            orderF: function(active, column){
                this.order = {
                    active: active,
                    column: column
                }

                this.getData()
            },
            orderBy: function(order, column){
                this.pCurrentSort = column
                this.currentSortDir = order
                this.data = this._.orderBy(this.data, column, order)
            },
            getData: function(){
                this.isLoading = false
                fetch(server + 'grides/produtos/vendidos/' + this.period + '/' + this.order.column, {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
                    .then(response => (response.json()))
                    .then(responseJSON => {
                        this.data = responseJSON.response
                        this.isLoading = true
                    })
                    .catch(error => {
                        console.log('Error exception', '=>', error)
                    })
            },
            formater: function(value){
                const formatter = new Intl.NumberFormat('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2
                })

                return formatter.format(value)
            }
        },
        mounted(){
            this.getData()
        },
        watch: {
            period: function(newVal, oldVal){
                if(newVal == 7){
                    this.periodText = 'nos ultimos  7 Dias'
                }else{
                    this.periodText = 'no ultimo 1 Dia'
                }
                this.getData()
            }
        }
    }
</script>
<style scoped>

</style>